import React from "react";

const TipsNormalization = ({ row }) => {
  return <div>{row?.tips?.toLocaleString()}</div>;
};

export default TipsNormalization;
